import { Outage, OutageApiResponse } from '@/apis/outages/types/outagesApi';
import { PaginatedResponse, PaginatedResponseFromApi } from '@/types';

export const outageFromApiAdapter = (outage: OutageApiResponse): Outage => {
  return {
    outageId: outage.OutageID,
    siteId: outage.SiteID,
    siteName: outage.SiteName,
    outageStart: outage.OutageStart,
    outageEnd: outage.OutageEnd,
    outageName: outage.OutageName,
    notes: outage.Notes ?? null,
    riskFactor: outage.RiskFactor ? outage.RiskFactor * 100 : 0,
    outagePercentile: outage.OutagePercentile ?? 0,
    outageNormalized0_100: outage.OutageNormalized0_100 ?? 0,
    workerCount: outage.WorkerCount ?? 0,
    ...(outage.HighRiskCount !== undefined && {
      highRiskCount: outage.HighRiskCount,
    }),
    ...(outage.LowRiskCount !== undefined && {
      lowRiskCount: outage.LowRiskCount,
    }),
    ...(outage.MidRiskCount !== undefined && {
      midRiskCount: outage.MidRiskCount,
    }),
  };
};

export const outagesFromApiAdapter = (
  response: PaginatedResponseFromApi<OutageApiResponse>,
): PaginatedResponse<Outage> => {
  return {
    results: response?.results.map(outageFromApiAdapter) ?? [],
    total: response.total,
    limit: response.limit,
    offset: response.offset,
    nextOffset: response.next_offset,
    prevOffset: response.prev_offset,
  };
};
